import { EllipsisVIcon, PencilAltIcon, useRouter } from '@forgeglobal/design-framework'
import { PopoverAction, PopoverListItem, PopoverListItemIcon, PopoverListItemText } from 'isolated-design-library'
import { Routes } from 'util/Routes'
import React, { Fragment } from 'react'

interface AccountActionsProps {
  accountId: string
}

export const AccountActions: React.FC<AccountActionsProps> = ({ accountId }) => {
  const { history } = useRouter()

  const handleEdit = () => {
    history.push(Routes.account(accountId))
  }

  const actions = (
    <Fragment>
      <PopoverListItem button onClick={handleEdit}>
        <PopoverListItemIcon>
          <PencilAltIcon />
        </PopoverListItemIcon>
        <PopoverListItemText>Edit</PopoverListItemText>
      </PopoverListItem>
    </Fragment>
  )

  return <PopoverAction icon={<EllipsisVIcon />} actionMenu={actions} />
}
